import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ReactSlider from 'react-slider';
import { withTranslation } from 'react-i18next';
import HeartIcon from './HeartIcon';
import { TooltipManager, TooltipPopper } from '../../Tooltip';
import { Particles } from './Particles';
import { isLove, isHate, midPoint, valueRange, loveScoreToHintLevel, } from '../redux/scales';
import s from './LoveSlider.scss';
var LoveSliderContent = /** @class */ (function (_super) {
    __extends(LoveSliderContent, _super);
    function LoveSliderContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoveSliderContent.prototype.render = function () {
        var _a = this.props, className = _a.className, _b = _a.type, type = _b === void 0 ? 'card' : _b, _c = _a.orientation, orientation = _c === void 0 ? 'vertical' : _c, lovePercentage = _a.lovePercentage, onBeforeLoving = _a.onBeforeLoving, onCancelLoving = _a.onCancelLoving, onLoveChanged = _a.onLoveChanged, onLoveChanging = _a.onLoveChanging, isLoveInProgress = _a.isLoveInProgress, justLoved = _a.justLoved;
        return (React.createElement("div", { className: classnames(s['root'], isLoveInProgress && s['is-open'], s[type], s[orientation], className), onMouseEnter: onBeforeLoving, onMouseLeave: onCancelLoving },
            type === 'devpage'
                ? this.renderHeartIconWithTooltip()
                : this.renderHeartIcon(),
            React.createElement("div", { className: classnames(s['slider'], isLove(lovePercentage || midPoint) && s['love']) },
                React.createElement(ReactSlider, { handleClassName: s['handle'], className: s['bar'], onChange: onLoveChanging, onAfterChange: onLoveChanged, orientation: orientation, value: lovePercentage, defaultValue: midPoint, max: valueRange, invert: orientation === 'horizontal' }, this.renderSliderIcon(type))),
            justLoved && React.createElement("div", { className: s['plus-one'] }, "+1")));
    };
    LoveSliderContent.prototype.renderSliderIcon = function (type) {
        var _a = this.props, lovePercentage = _a.lovePercentage, hasLoveChanged = _a.hasLoveChanged, t = _a.t;
        if (type === 'devpage') {
            var hint = loveScoreToHintLevel(lovePercentage);
            var hintText = t([
                "loveMeter.hint." + hint,
                hasLoveChanged ? '' : 'loveMeter.hint.cue',
            ]);
            var hintTitle = t("loveMeter.hint.title." + hint, { defaultValue: '' });
            return (React.createElement(TooltipManager, { renderReference: function (_a) {
                    var ref = _a.ref;
                    return (React.createElement("div", { className: s['slider-icon'] },
                        React.createElement("div", { ref: ref, className: s['handle-hook'] }),
                        lovePercentage !== undefined && (React.createElement(Particles, { lovePercentage: lovePercentage, className: s['particles'] }))));
                } }, (hintTitle || hintText) && (React.createElement(TooltipPopper, { placement: "left", modifiers: { offset: { offset: '0, 8' } } },
                React.createElement("div", { className: s['tooltip'] },
                    hintTitle && (React.createElement("div", { className: s['hint-title'] }, hintTitle)),
                    hintText && React.createElement("div", { className: s['hint-text'] }, hintText))))));
        }
        return (React.createElement("div", { className: s['slider-icon'] },
            React.createElement("div", { className: s['handle-hook'] }),
            lovePercentage !== undefined && (React.createElement(Particles, { lovePercentage: lovePercentage, className: s['particles'] }))));
    };
    LoveSliderContent.prototype.renderHeartIconWithTooltip = function () {
        var _this = this;
        var _a = this.props, isLoveInProgress = _a.isLoveInProgress, isFirstLove = _a.isFirstLove, t = _a.t;
        return (React.createElement(TooltipManager, { renderReference: function (_a) {
                var ref = _a.ref;
                return _this.renderHeartIcon(ref);
            } }, !isLoveInProgress && isFirstLove && (React.createElement(TooltipPopper, { placement: "top" },
            React.createElement("div", { className: s['tooltip'] },
                React.createElement("div", { className: s['hint-text'] }, t('loveMeter.hint.firstLove')))))));
    };
    LoveSliderContent.prototype.renderHeartIcon = function (innerRef) {
        var _a = this.props, iconClassName = _a.iconClassName, activeIconClassName = _a.activeIconClassName, isFilled = _a.isFilled, onIconClick = _a.onIconClick, isFirstLove = _a.isFirstLove;
        return (React.createElement("button", { ref: innerRef, className: s['button'], onClick: onIconClick },
            React.createElement(HeartIcon, { iconState: this.getHeartIconState(), className: classnames(s['anchor-icon'], iconClassName, isFirstLove && s['throb']), activeClassName: activeIconClassName, isFilled: isFilled })));
    };
    LoveSliderContent.prototype.getHeartIconState = function () {
        var _a = this.props, lovePercentage = _a.lovePercentage, hasLoved = _a.hasLoved;
        if (!hasLoved || typeof lovePercentage === 'undefined') {
            return 'base';
        }
        if (isHate(lovePercentage)) {
            return 'broken';
        }
        return 'active';
    };
    return LoveSliderContent;
}(React.Component));
export { LoveSliderContent };
export default withTranslation()(LoveSliderContent);
//# sourceMappingURL=LoveSliderContent.js.map